import { render, staticRenderFns } from "./CompanyHealthFilter.vue?vue&type=template&id=6bf764a2&"
import script from "./CompanyHealthFilter.vue?vue&type=script&lang=ts&"
export * from "./CompanyHealthFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports